import { useCallback } from 'react';

import { throttle } from '@/utils/throttle.ts';

/**
 * Returns a render-persisent throttled version of a function to be used in components.
 * @param callback the function to be throttle
 * @param delay the minimum number of milliseconds between two calls of the throttled function
 * @returns the persistent function that will call the original function at most once every `delay` milliseconds
 */
export const useThrottle = <T extends unknown[]>(callback: (...arg: T) => void, delay: number) =>
  useCallback(throttle(callback, delay), []);
